var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 16.6665H3.33329V3.33317C3.33329 3.33317 7.08329 3.33317 9.58329 3.33317C10.4166 3.33317 10.4166 1.6665 9.58329 1.6665C7.08329 1.6665 3.33329 1.6665 3.33329 1.6665C2.40829 1.6665 1.66663 2.4165 1.66663 3.33317V16.6665C1.66663 17.5832 2.40829 18.3332 3.33329 18.3332H16.6666C17.5833 18.3332 18.3333 17.5832 18.3333 16.6665C18.3333 16.6665 18.3333 13.7498 18.3333 10.4165C18.3333 9.58317 16.6666 9.58317 16.6666 10.4165C16.6666 13.7498 16.6666 16.6665 16.6666 16.6665ZM12.5 1.6665C11.6666 1.6665 11.6666 2.9165 12.5 3.33317C14.1666 4.1665 14.1666 4.1665 14.1666 4.1665C14.1666 4.1665 9.99996 8.33317 6.66663 11.6665C5.41663 12.9165 7.08329 14.5832 8.33329 13.3332C11.6666 9.99984 15.8333 5.83317 15.8333 5.83317C15.8333 5.83317 15.8333 5.83317 16.6666 7.49984C17.0833 8.33317 18.3333 8.33317 18.3333 7.49984C18.3333 4.99984 18.3333 1.6665 18.3333 1.6665C18.3333 1.6665 15 1.6665 12.5 1.6665Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNew);
export default __webpack_public_path__ + "static/media/open-new.4aed65db.svg";
export { ForwardRef as ReactComponent };